import {
  ErrorCode,
  type InventoryQueryReqDto,
  type RafflesResDto,
  type RaffleItemResDto,
} from '@web/common';
import { setupMobX } from '../../../../util/setupMobX';
import { action, makeObservable, observable, runInAction } from 'mobx';
import {
  activeRaffleData,
  betOnRaffle,
  futureRaffleData,
  pastRaffleData,
  raffleByIdData,
} from '../../../../request/authenticated-requests/raffle';
import { showErrorNotification } from '../../../../component/notification';
import { handleRequestError } from '../../../../request';

export class RaffleStore {
  @observable public activeRaffles: RafflesResDto = [];
  @observable public upcomingRaffles: RafflesResDto = [];
  @observable public pastRaffles: RafflesResDto = [];
  @observable public specificRaffle: RaffleItemResDto | null = null;

  @observable public error: string | null = null;
  @observable public queryFilter: InventoryQueryReqDto = {};

  @observable public isLoadingActive = true;
  @observable public isLoadingFuture = true;
  @observable public isLoadingPast = true;
  @observable public isLoadingSpecificRaffle = false;

  constructor() {
    makeObservable(this);
  }

  @action public loadActiveRaffles = () => {
    this.isLoadingActive = true;

    activeRaffleData()
      .then((data) => runInAction(() => (this.activeRaffles = data)))
      .catch(() => showErrorNotification())
      .finally(() => runInAction(() => (this.isLoadingActive = false)));
  };

  @action public loadFutureRaffleData = () => {
    this.isLoadingFuture = true;

    futureRaffleData()
      .then((data) => runInAction(() => (this.upcomingRaffles = data)))
      .catch(() => showErrorNotification())
      .finally(() => runInAction(() => (this.isLoadingFuture = false)));
  };

  @action public loadPastRaffleData = () => {
    this.isLoadingPast = true;

    pastRaffleData()
      .then((data) => runInAction(() => (this.pastRaffles = data)))
      .catch(() => showErrorNotification())
      .finally(() => runInAction(() => (this.isLoadingPast = false)));
  };

  @action public loadRaffleById = (raffleId: string) => {
    this.isLoadingSpecificRaffle = true;
    this.specificRaffle = null;

    raffleByIdData(raffleId)
      .then((data) => runInAction(() => (this.specificRaffle = data)))
      .catch(() => showErrorNotification())
      .finally(() => runInAction(() => (this.isLoadingSpecificRaffle = false)));
  };

  @action public betOnRaffle = (
    raffleId: string,
    successAction: () => void,
    errorAction: () => void,
  ) => {
    betOnRaffle(raffleId)
      .then(() => {
        this.loadActiveRaffles();
        successAction();
      })
      .catch((error) => {
        handleRequestError(error, [
          ErrorCode.NotEnoughLoyalityPoints,
          () => {
            showErrorNotification(ErrorCode.NotEnoughLoyalityPoints);
            errorAction();
          },
        ]);
      });
  };
}

const { provider, useStore } = setupMobX<RaffleStore>();
export const useRaffleStore = useStore;
export const RaffleStoreProvider = provider;
